const getDocumentScrollTop = () => Math.max(document.body.scrollTop, document.documentElement.scrollTop);

const setDocumentScrollTop = value => {
    document.documentElement.scrollTop = value;
    document.body.scrollTop = value;
};

/**
 * @description Scrolls from a given position to a target position.
 * @param {number} from - The start position in pixels.
 * @param {number} to - The target position in pixels.
 * @param {number} duration - The scroll animation duration.
 */
// eslint-disable-next-line id-length
const scrollTo = (from, to, duration = 300) => {
    if(getDocumentScrollTop() === to) {
        return;
    }

    const start = from;
    const diff = to - getDocumentScrollTop();
    const scrollStep = Math.PI / (duration / 10);
    const initialDirection = Math.sign(to - from);
    let request;

    let count = 0, currPos = 0, lastPos = from;

    const scrolling = () => {
        if(getDocumentScrollTop() !== to) {
            count++;
            currPos = start + diff * (0.5 - 0.5 * Math.cos(count * scrollStep));

            if(Math.sign(currPos - lastPos) !== initialDirection) {
                window.cancelAnimationFrame(request);
            } else {
                lastPos = currPos;
                window.scrollTo(0, currPos);
                request = window.requestAnimationFrame(scrolling);
            }
        }
    };

    request = window.requestAnimationFrame(scrolling);
};

/**
 * @description Scrolls the page to the top.
 * @param {number} [timing=250] - The time to scroll.
 */
const toTop = (timing = 250) => {
    scrollTo(getDocumentScrollTop(), 0, timing);
};

/**
 * @description Scrolls the page to the bottom.
 * @param {number} [timing=250] - The time to scroll.
 */
const toBottom = (timing = 250) => {
    const {body} = document,
        html = document.documentElement,
        offsetHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight),
        clientHeight = Math.max(body.clientHeight, html.clientHeight);

    scrollTo(getDocumentScrollTop(), offsetHeight - clientHeight, timing);
};

module.exports = {
    getDocumentScrollTop,
    scrollTo,
    setDocumentScrollTop,
    toBottom,
    toTop
};
